/* Sleep LP Dejavu — quote carousel
   One slide per view, pointer drag + arrow controls. */
(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-dejavu-track]');
    var viewport = root.querySelector('[data-dejavu-viewport]');
    if (!track || !viewport) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-dejavu-slide]'));
    if (!slides.length) return;

    var index = 0;
    var dragStartX = 0;
    var dragCurrentX = 0;
    var isDragging = false;
    var dragOffset = 0;

    function slideWidth() { return viewport.offsetWidth; }

    function applyTransform(extra) {
      var offset = -index * slideWidth() + (extra || 0);
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    function update() {
      applyTransform(0);
      var prevBtn = root.querySelector('[data-dejavu-prev]');
      var nextBtn = root.querySelector('[data-dejavu-next]');
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= slides.length - 1;
    }

    function go(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      update();
    }

    var prevBtn = root.querySelector('[data-dejavu-prev]');
    var nextBtn = root.querySelector('[data-dejavu-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });

    // Pointer drag
    function onPointerDown(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      isDragging = true;
      dragStartX = e.clientX;
      dragCurrentX = e.clientX;
      dragOffset = 0;
      track.classList.add('is-dragging');
      track.setPointerCapture && track.setPointerCapture(e.pointerId);
    }
    function onPointerMove(e) {
      if (!isDragging) return;
      dragCurrentX = e.clientX;
      dragOffset = dragCurrentX - dragStartX;
      applyTransform(dragOffset);
    }
    function onPointerUp() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      var threshold = slideWidth() * 0.18;
      if (dragOffset < -threshold) go(index + 1);
      else if (dragOffset > threshold) go(index - 1);
      else update();
      dragOffset = 0;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', onPointerUp);

    // Prevent click-drag selection of inner text
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // Resize
    var resizeObs;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObs = new ResizeObserver(function () { update(); });
      resizeObs.observe(viewport);
    } else {
      window.addEventListener('resize', update);
    }

    update();
  }

  function init() {
    document.querySelectorAll('[data-sleep-dejavu]').forEach(initSlider);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-sleep-dejavu]');
    if (root) initSlider(root);
  });
})();
